import angular from 'angular';
 import SlidersComponent from './sliders.component';

 import SlidersT1Module from './sliders-t1/sliders-t1';

let SlidersModule = angular.module('home.sliders', [
   SlidersT1Module.name
])
   .component('sliders', SlidersComponent);

export default SlidersModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/home/sliders/sliders.js
 **/